import { Button, FormInstance } from 'antd';
import { FC } from 'react';

import { useTranslate } from 'hooks';

import { ReactComponent as Close } from 'assets/icons/close.svg';

import { IFilter, IFilterValues, ISavedFilter } from 'models';

import styles from './index.module.scss';

export const Filters: FC<{
	filters: IFilter[];
	setActiveFiler?: (v: ISavedFilter) => void;
	onReset: () => void;
	form: FormInstance;
	values: IFilterValues;
}> = ({ filters, setActiveFiler, onReset, form, values }) => {
	const { clearAllText } = useTranslate(['clearAllText']);

	const onDelete = (item: IFilter) => {
		if (setActiveFiler) {
			setActiveFiler({} as ISavedFilter);
		}

		if (typeof values[item.fieldName as keyof IFilterValues] === 'string') {
			form.setFieldValue(item.fieldName, undefined);
		} else {
			const arr = values[item.fieldName as keyof IFilterValues];
			if (Array.isArray(arr)) {
				const value = arr.filter((i: string) => `${i}` !== `${item.name}`);
				form.setFieldValue(item.fieldName, value);
			}
		}
	};

	return (
		<div className={`${styles.root} ${styles.values}`}>
			<div className={styles.filterValues}>
				{filters.map((item: IFilter) => {
					return (
						<div key={item.name} className="filter">
							{item.value}
							<Button
								type="link"
								icon={<Close />}
								onClick={() => {
									onDelete(item);
								}}
							/>
						</div>
					);
				})}
			</div>

			<Button type="link" className={styles.clear} onClick={onReset}>
				{clearAllText}
			</Button>
		</div>
	);
};
